/**
 * @fileoverview Sources attribution text component
 * @active MAINTAINED - Used in all detail pages
 *
 * This component displays the attribution text for data sources
 * used across the application. It's consistently placed at the
 * bottom of detail pages.
 *
 * @see {@link src/components/personBy_Id/PersonById.tsx} - Usage in person profile
 * @see {@link src/components/companies/company_Id/Company_Id.tsx} - Usage in company profile
 */

import { Text, type TextProps } from "@chakra-ui/react";

import { h_400_12_135_48 } from "@/styles/fontStyles";

/**
 * Props for the SourcesBottomText component
 */
interface SourcesBottomTextProps {
  /** Optional custom styling to override defaults */
  customStyle?: TextProps;
}

/**
 * Component for displaying attribution text for data sources
 * @param props - Component properties
 * @returns A text component with attribution information
 */
export const SourcesBottomText = ({
  customStyle = {},
}: SourcesBottomTextProps) => {
  return (
    <Text
      {...h_400_12_135_48}
      color={"gray"}
      px={"24px"}
      mb={"24px"}
      mt={{ base: "40px", smx: "40px", lg2: "80px" }}
      // display={{ base: "none", lg: "block" }}
      textAlign={"center"}
      {...customStyle}
    >
      Source(s): This page includes data and analysis provided by the company,
      OpenAI, and our research analysts
    </Text>
  );
};
